export default __webpack_public_path__ + "static/media/DuerfpDarkInActive.1ed25971.svg";